import copy from 'copy-to-clipboard';
import BloggerController from "./blogger_controller";
import $ from 'jquery';
import "../../../assets/javascripts/admin/selectize.js";
import "../../../assets/stylesheets/admin/selectize.bootstrap3.css";
import { BLOGGER_UTM_LINK } from "../routes";

export default class extends BloggerController {
  static targets = ['restaurantTypeSelect', 'individual', 'group', 'branch', 'individualSelect', 'groupSelect', 'branchSelect', 'result'];
  restaurantType = null;

  initialize() {
    const selectType = $(this.restaurantTypeSelectTarget);
    this.restaurantType = this.restaurantTypeSelectTarget.value;
    selectType.selectize({
      onChange: (v) => this.restaurantTypeSelectOnChange(v)
    });
    const app = this;
    $('.chosen-select').each(function() {
      $(this).selectize({
        onChange: (v) => app.setResultEmpty()
      });
    })
  }

  restaurantTypeSelectOnChange(selected){
    this.restaurantType = selected;
    switch (selected) {
      case 'individual':
        this.showIndividual();
        break;
      case 'group':
        this.showGroup();
        break;
      case 'branch':
        this.showBranch();
        break;

      default:
        break;
    }
    this.setResultEmpty();
  }

  setResultEmpty() {
    this.setEmpty(this.resultTarget);
  }

  showIndividual() {
    this.individualTarget.classList.remove('dn!');
    this.groupTarget.classList.add('dn!');
    this.branchTarget.classList.add('dn!');
  }

  showGroup() {
    this.groupTarget.classList.remove('dn!');
    this.individualTarget.classList.add('dn!');
    this.branchTarget.classList.add('dn!');
  }

  showBranch() {
    this.branchTarget.classList.remove('dn!');
    this.groupTarget.classList.add('dn!');
    this.individualTarget.classList.add('dn!');
  }

  copy(e) {
    e.preventDefault;
    const el = e.target;
    const link = el.getAttribute('data-link');
    copy(link);
    this.resultTarget.append(this.htmlToElement(`<div class="alert alert-success alert-dismissible fade show mt2" role="alert">
      Copied to clipboard
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>`));
    setTimeout(() => {
      $(this.resultTarget).find('button[data-dismiss="alert"]').click();
    }, 1000);
  }

  async submit(e) {
    if(e.target.classList.contains('disabled')) return;
    e.target.classList.add('disabled');
    this.setLoading(this.resultTarget);

    const { data } = await this.axios.post(BLOGGER_UTM_LINK,
      { resource_type: this.restaurantType, resource_id: this.selectedResourceId }
    ).catch((error) => {
      window.Rollbar.error(error);
      this.resultTarget.innerHTML = `
        <div class="alert alert-danger mt3" role="alert">Sorry, something went wrong</div>
      `;
      return {};
    });
    await this.processPartial(data);
    e.target.classList.remove('disabled');
  }

  get selectedResourceId() {
    switch (this.restaurantType) {
      case 'individual':
        return this.individualSelectTarget.value;
      case 'group':
        return this.groupSelectTarget.value;
      case 'branch':
        return this.branchSelectTarget.value;

      default:
        break;
    }
  }
}
